jQuery(function ($) {
    $(document).ready(function () {
        $('.ingredients-list__item').first().addClass('active');

        $('.ingredients-list__item').on('click', function () {
            let item = $(this).attr('data-ingredient-item');

            $('.ingredients-list__item').removeClass('active');
            $(this).addClass('active');
            $('.ingredient-main').fadeOut(5);
            $('.ingredient-main[data-ingredient-item = ' + item + ']').fadeIn(100);

            if (window.matchMedia('(max-width: 1023.98px)').matches) {
                $('html, body').animate({
                    scrollTop: $('.ingredients-product__right-block').offset().top
                }, 1000);
            }
        });

    });
});